export const PRELAUNCH_MODE = true;

export const PRELAUNCH_MESSAGE =
  "Mode pré-lancement : aucun service financier réel n’est actif. " +
  "Aucun achat/vente crypto, aucun dépôt/retrait fiat, aucun KYC.";

const PAYMENT_PRESENTATIONS = {
  live: {
    state: "live",
    bannerVisible: true,
    bannerBadge: "Paiements actifs",
    bannerMessage: "Les paiements réels sont disponibles uniquement dans les rubriques ouvertes. Les autres parcours restent en validation.",
    navigationLabel: "Paiements actifs",
  },
  sandbox: {
    state: "sandbox",
    bannerVisible: true,
    bannerBadge: "Paiements test actifs",
    bannerMessage:
      "Paiements de test disponibles dans les rubriques activées ; la configuration ne vaut pas validation de tous les parcours. " +
      "Aucun débit ni reversement réel n’est effectué.",
    navigationLabel: "Paiements test",
  },
  sandbox_validating: {
    state: "sandbox-validating",
    bannerVisible: true,
    bannerBadge: "Paiements test en validation",
    bannerMessage:
      "Stripe Connect est raccordé en environnement test. " +
      "Les destinations de suivi et les parcours restent à valider ; aucun argent réel ne circule.",
    navigationLabel: "Paiements test",
  },
  prelaunch: {
    state: "prelaunch",
    bannerVisible: PRELAUNCH_MODE,
    bannerBadge: "Pré-lancement",
    bannerMessage: PRELAUNCH_MESSAGE,
    navigationLabel: "Paiements bêta",
  },
};

export function resolvePaymentPresentation(capabilities) {
  const state = String(capabilities?.payment?.public_status?.state || "prelaunch");
  return PAYMENT_PRESENTATIONS[state] || PAYMENT_PRESENTATIONS.prelaunch;
}
